export default __webpack_public_path__ + "static/sketch-2afd60810cbadc93c6fe00bd90be5d58.png";